import React from "react";
import { Link } from "react-router-dom";
import blogs from '../Data/blogs';
export default function Blog() {
  return (
    <div style={{ padding: "120px 20px", maxWidth: "1100px", margin: "auto" }}>
      <h1 style={{ textAlign: "center", marginBottom: "40px" }}>Our Blog</h1>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
          gap: "25px"
        }}
      >
        {blogs.map((blog) => (
          <div
            key={blog.slug}
            style={{
              background: "var(--card-bg)",
              border: "1px solid var(--border)",
              borderRadius: "10px",
              padding: "20px"
            }}
          >
            <h3>{blog.title}</h3>

            <p style={{ color: "var(--text-muted)" }}>{blog.date}</p>

            <p>{blog.excerpt}</p>

            <Link
              to={`/blog/${blog.slug}`}
              style={{
                color: "var(--orange)",
                fontWeight: "600",
                textDecoration: "none"
              }}
            >
              Read More →
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}